<div>
  @if (mode=='preview') {
    <div>
      <div class="modal-header">
        <h4 class="modal-title mb-2">{{isDefaultPreview ? 'Default Assets Preview' : 'Confirmation'}}</h4>
        <button type="button" class="close dismiss" aria-label="Close" (click)="Onconfirmation('dismiss')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [ngClass]="isDefaultPreview ? 'mb-3' : ''">
        @if (!isDefaultPreview) {
          <p class="mb-1"><strong>Are you sure you want to save Assets ?</strong></p>
        }
        <div class="wab-wrapper noSelect">
          <div #featurePrevieContainer></div>
          <div class="screen">
            <div #featurePrevieContainer></div>
          </div>
          <!-- <div class="content" *ngIf="wabType == 'whack_a_bingo_chat'">
          <div class="wab-view">
            <div class="wab-bg">
              <img class="bgImg" [src]="getImg('bg')" alt="wab-bg" srcset="">
              <div class="screen">
                <wab-game [gameImageAssets]="gameAssets" [wabTextColor]="txtColor"
                  [gWhackConfig]="wabConfig" [bonusData]="bonusType" (SoundsData)="playWabSounds($event)"
                  (gameEnd)="gameEnd()" (gHitsUpdate)="updatesHits()">
                </wab-game>
              </div>
            </div>
            <div class="wab-close" (click)="onClose()">
              <span class="closeBtn">&times;</span>
            </div>
            <div class="wab-error" *ngIf="internetError == 'true'">
              <div class="wab-errorMsg">
                <span *ngIf="error == 'true'">{{'wab_error_msg' | gtranslate}}</span>
                <span *ngIf="error == 'false'">{{'wab_internet_error_heading' | gtranslate}}</span>
                <span *ngIf="error == 'false'">{{'wab_internet_error_msg' | gtranslate}}</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      @if (!isDefaultPreview || wabType) {
        <div class="modal-footer">
          <button type="button" class="gms-btn secondary" (click)="Onconfirmation('decline')">Cancel</button>
          <button type="button" class="gms-btn primary" (click)="Onconfirmation('accept')">Save</button>
        </div>
      }
    </div>
  </div>
}
@if (mode=='editable') {
  <div>
    <div class="wab-wrapper noSelect">
      <div class="screen">
        <div #featurePrevieContainer></div>
      </div>
    </div>
  </div>
}
</div>